module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('i', [_vm._v("PROLOGUE")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "chapterDateline",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("South Bimini"), _c('br'), _vm._v(" September")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("T")])]), _vm._v("he sound of the bloodcurdling scream was as startling as the roar of thunder on a cloudless day.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Vanessa Loren immediately felt chilled to the bone, a sense of foreboding and fear as deep-seated as any natural instinct seeming to settle into her, blood, body and soul.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("So jarring! It brought casual conversation to a halt, brought those seated to their feet, brought fear to all eyes. It was the sound of the scream, the very heartfelt terror within it, which had been lacking during the day’s work.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The ocean breeze had been beautiful throughout the afternoon and evening; it seemed almost as if the hand of God was reaching down to gently wave off the last dead heat of the day, leaving a balmy temperature behind as the sun sank in the western horizon with an astonishing palette of crimson, magenta, mauve and gold.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("The film crew had set up camp on the edge of the sparse pine forest, just yards away from the lulling sound ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("of the ocean. The Bahamian guides who had brought them and worked with them had been courteous, fun and knowledgeable, and there was little not to like about the project, especially as night fell and the last of the blazing, then pastel, shades faded into the sea, and it and the horizon seemed to stretch as one, the sky meeting the ocean in a blur.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("A bonfire burned with various shades from brilliant to pale in the darkness, and the crew gathered around as it grew dark. South Bimini was sparsely inhabited, offering a small but popular fisherman’s restaurant and little more, unlike the more tourist-friendly North Bimini, where numerous shops, bars and restaurants lined what was known as The King’s Highway in Alice Town.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("They had taken it a step further than South Bimini, choosing to film on one of the several little uninhabited islands jutting out to the southwest. One with a name that had greatly appealed to Jay.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Haunt Island.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A long time ago, there had been a pirate massacre here. Over the years, truth and legend had merged, and it was this very story that Vanessa had used in her script for the low-budget horror film they were shooting.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("So infamous years ago, Haunt Island was currently just a place where boaters came now and then. An island filled with scrub and pines, a single dock and an abundance of beach. Out here, tourism wasn’t plentiful—the terrain remained wild and natural, beloved by naturalists and campers.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("There had been more people in their group, but now they were down to ten. There were Georgia Dare and Travis Glenn, the two actors playing the characters who ")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("remained alive in the script; Jay Allen, director; Barry Melkie, sound; Zoe Cally, props, costumes and makeup; Carlos Roca, lighting; Bill Hinton, and Jake Magnoli, the two young production assistants/lighting/sound/gophers/wherever needed guys; their Bahamian escort and guide, Lew Sanderson; and Vanessa herself, writer and backup with the cameras and underwater footage.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("It was all but a wrap. The historical legend filled with real horror that was sure to be a box-office hit on a shoestring budget had been all but completed, and they’d been winding down, crawling out of their tents to enjoy the champagne, laughing and lazing against the backdrop of the sunset and the breeze.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("And then the sound of the scream, so much more chilling and horrible than any sound Georgia Dare had managed to emit throughout the filming.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Until that moment, Vanessa Loren had enjoyed the project. It was simple enough—a low-budget horror flick that actually had a plot. She had written the script. In addition, she and Jay were financially committed to the project, which made them both willing to work in any capacity. She was ready to do instant rewrites as needed because of the actors and the environment, and she could film underwater shots and even pitch in as second camera for many of the land shots.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("Jay, the director, was planning on making a bundle; he was counting on the success of such films as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Blair Witch Project")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paranormal State")]), _vm._v(". Vanessa and Jay had known each other forever, and had both gone to film school at NYU. He’d contacted her while she was working back in Miami after she’d gotten her master’s degree at the University of Miami. He’d talked the good ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("talk on getting together and finding a few investors to finance a really good low-budget flick.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Luckily, she had just been nicely paid for work she had done writing and filming an advertisement for dive gear. It had been one of the few projects she had worked on that hadn’t been rewritten by a dozen people before coming to fruition—and it had been a sixty-second spot.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jay agreed with her that if they were going to do the project, an independent endeavor, it had to be done really well. However, they were also looking for commercial success. So the script was well written but also included the usual assortment of teen-slasher-flick characters—the jock who counted his conquests with scratches on his football helmet, the stoner guitar boy, the struggling hero, the popular slut coming on to the hero and the good-girl bookworm. So far, two characters had been killed in the water, two had disappeared from the boat—and two had to fight the evil, reborn pirates on land and sea and somehow survive until help could come to the patch of sand where they’d been grounded in the Atlantic.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The scream.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Vanessa had been sitting by the fire, sipping a glass of champagne and chatting with Jay, Lew and Carlos. They’d broken it open just a few minutes earlier, taking a minute to relax before they all gathered to cook dinner over the fire and the camp stoves they’d brought and finish off the rest of the champagne.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("At the scream, she, like the others, stopped what she was doing. They looked at one another in the eerie light ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("produced by the flames in the darkness, then bolted up and started running toward the sound.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Vanessa was in the lead when Georgia came tearing down the beach toward them. Vanessa caught the young woman, trying to hold her, trying to find out what had happened. “Georgia! Stop, stop!” Georgia Dare, a stunning twenty-one-year old blonde, stared at her with eyes as wide as saucers. “Georgia, it’s me, Vanessa. What’s wrong?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Nessa…Nessa…oh my God, oh, no, no…!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Georgia started to scream again, trying to shake Vanessa’s hold.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Georgia!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("By then, everyone had come, bursting out of their camp tents, forgetting whatever task they had been involved in.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The others gathered behind her while Jay came forward. “Georgia, damn it, what the hell kind of a prank is this?” he demanded. Once, Georgia had tried to pretend that a stunt knife was real and that she’d been stabbed by a woman from the Retirees by the Sea trailer park back in the Keys.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“The bones, the bodies…they are alive, they don’t like us, they’re going to kill us…they’re angry…we’ll all die!” Georgia blurted.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Damn it, I’ve had it,” Jay said with disgust, turning away. Most of the others did the same.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Vanessa didn’t. Georgia was shaking violently. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("And that scream! The sound of that scream still seemed to be chilling her blood.")])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("“They’re going to kill us all. Kill us all,” Georgia said. Her eyes fell directly on Vanessa’s then, and she ")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("was suddenly as strong as a sumo wrestler, breaking free from Vanessa’s hold and gripping her shoulders instead. “They’re real! They’re going to kill us, don’t you understand, we have to get out of here! They’re coming out of the sand. I saw them…the arms, the hands, the skulls… I saw them, coming out of the sand.”")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Georgia, Georgia, please, stop it. Hey, come on, we’re filming a horror movie, remember?” Vanessa asked gently. “The guys probably set up some of the props to scare you,” She frowned suddenly. “What were you doing alone, way down on the beach?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Travis and I…Travis and I… Travis is gone.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Travis Glenn was the male lead, an exceptionally beautiful if not terribly bright young man.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Okay, where is Travis?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Gone. Gone. The pirate took him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“The pirate?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Georgia shook her head. “Maybe he wasn’t a pirate. I didn’t see him very clearly. But he was evil—he was like an evil shadow, skulking in the darkness. Travis was yelling, and he went after the shadow. He was mad. He thought you all were playing tricks. And then this monster came out of the sand, but he wasn’t right, he seemed to jerk around, like his bones were put back together wrong. And he took Travis and I started screaming and ran.”")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("Jay came back, hands on his lean hips, chest glistening in the darkness. “Slap her! Nessa, don’t look so damned concerned. She’s jerking us around and it isn’t funny. Damn you, Georgia. Look, I realize this isn’t anything major-budget, but the crew has worked hard and everyone is tired—and you’re acting like a complete ")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("bitch! It’s just not the time for practical jokes. Slap her, knock her out of it, Vanessa!”")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Vanessa glared at him and shook her head. Georgia wasn’t that good an actress. She had disagreed with casting the young woman, but she had looked phenomenal on film.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Let’s go down to the beach and see what scared her,” Vanessa suggested. She looked back at Lew, a big, broad-shouldered Bahamian man who had been one of their guides. “Do you think there’s anything down at the beach, Lew?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Sand,” he told her.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Let’s go see.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Georgia jerked away from her, shaking her head vehemently. “No, no, no! I am not going back there. I am not going back!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Carlos Roca, their lighting engineer, came toward them. He’d been close to both actors, and Georgia liked him. Vanessa did, too. He was a nice guy—even-tempered and capable. He took Georgia’s hands. “Hey, hey. I’ll stay here with you, and we’ll sit by the fire with the others while Lew, Jay and Vanessa go check it all out. How’s that?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Georgia looked up at him. Huge tears formed in her eyes and she nodded. “Travis is dead,” she told him. “Travis is dead.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jay looked at Zoe, who worked with the props, makeup and buckets of stage blood they’d been using. He glared sternly at her, then turned to Bill and Jake, the young production assistants, earning credit from the U of Miami. “Hey, you guys didn’t rig anything, did you—any practical jokes?”")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Zoe looked at him with incredulous disdain. “No. No, we did not.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jay looked from face to face and was obviously satisfied with the chorus of denials.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“All right, we’ll check it out,” Jay said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yes, yes. Come on, let’s do this,” Lew said with his pleasant and easy Bahamian accent. “We’ll find Travis and see what’s going on. Miss Georgia, you’re going to be just fine, honey.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But Georgia shook her head. “Travis is dead,” she repeated.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’ll light some torches from the fire,” Lew offered.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I don’t believe we’re doing this,” Jay said, tired and irritated as they started down the beach. “I made a mistake in casting, that’s for sure. We’re filming a legend, a horror flick, for God’s sake. She’s letting it all get to her. This is crazy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Lew chuckled softly. “Ah, yes, well, that’s the way it is with American slasher flicks, eh? Two young people drink and wander off into the woods or the pines to make love, and then the monster comes upon them. They are mistaken. This is Bimini. There are no monsters.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Vanessa stopped. They had come to the edge of the beach. A pine forest came almost flush with the water after a rise in the landscape.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Nothing,” Jay said. “There’s nothing out here at all.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Vanessa raised her torch to look around. She froze suddenly. There was nothing there now, but just feet from her, the sand looked as if it had been raked, and it was damp as well, as if someone had dumped buckets of water twenty feet inland from the shore.")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Look,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Someone was playing a joke on her—on her and Travis, maybe,” Jay said. He swore. “We’ve got one more day of filming to tie up loose ends, and I guess it’s natural that someone just feels the need to play practical jokes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“But where is Travis?” Vanessa asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Lew was hunkered down by the disturbed sand. “Interesting,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What?” Jay asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“It does look like something burst outward from the sand—more than it looks as if someone were digging in it,” Lew said. “As if it erupted, and was then smoothed over.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“We work with great props and special-effects people,” Jay said dryly. “Let’s get back. I’m tired as hell. Someone has to have some kind of sleeping pill Georgia can take.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’m not sure she should be taking a pill—” Vanessa began.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I am,” Jay interrupted her. “I need to sleep tonight!”")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("“I’ll take Georgia in with me,” Vanessa volunteered. She surprised herself. She hadn’t disliked Georgia; she just found the woman to be a little…vapid. But that night, she felt sorry for her. Georgia had dropped out of high school, certain that an actress didn’t need an education. She’d spent several years working as a model at car and boat shows, and Jay had discovered her because she’d gotten a local spot on television promoting a used-car dealer. Vanessa had to admit that Georgia might not be the most talented actress she knew, but she had been ")]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("professional and easy to work with. She was pretty sure that Georgia had never gotten a lot of support from her parents or anyone else.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("She also knew that she had been lucky. She had been raised by parents who had cared more about their children than anything else in life. Her mother and father had been avid historians, readers, writers and divers, and they had done everything in their power to put their two children through college. She loved history and she loved diving. Her actual forte was in script writing, but in Hollywood, that was a difficult route, with scripts being rewritten so many times that you seldom recognized your own work at the end, and you seldom received credit for a project, either. It had been necessary, in her mind, to learn cameras as well, and with her background, underwater work was a natural. She was driven and she was passionate about her work, so she’d jumped at the chance to work on this movie when Jay called her.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jay loved horror movies, and they had loved each other forever. Not as boyfriend and girlfriend—they had known each other since grade school in the small town of Micanopy, Florida. He had a chance with this movie, and she wanted him to have his chance. She wanted this chance for herself, too.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She had said from the beginning that she was in only if she got her own tent.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But tonight she’d bring Georgia in with her and be a mother hen.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("Carlos had been settling the young woman down; the two were sitting by the fire with large plastic cups—Vanessa was pretty sure they contained something a ")]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("lot harder than champagne. As Vanessa, Jay and Lew returned, Georgia jumped to her feet, staring at them. “See? See? I told you!”")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Jay took Georgia by the shoulders and tried to be calm and reassuring. “Georgia, all I can think is that Travis is playing some kind of a trick on you, sweetie.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“No, no! You have to go look for Travis!” Georgia said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I guess we should,” Vanessa said quietly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jay stared at her with aggravation. “Look for him? Oh, please! You know damned well that Travis is the one who played this ridiculous joke, or he’s in on it! And there’s nothing there, Georgia. No hands, no skulls, no monsters. Georgia, you’ve got to get some sleep. I need some sleep.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“No, no, I saw it!” Georgia said, shaking her head in fear. She glared furiously at Jay. “I have to get out of here. I won’t stay here!” she insisted.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You’ve got to be joking!” Jay declared irritably. “Georgia, you were touting used cars, for God’s sake! This could make you the new scream queen!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Georgia was obviously terrified beyond caring. “I don’t care! I don’t care if I spend the rest of my life as a waitress. I have to get off this island—now. Now!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“It’s dark!” Jay reminded her.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Hey, hey, it’s all right, we’re fifty miles from Miami, and we’ve got a good speedboat. I can take her in and be back to help with any follow-up or backup shots that we need tomorrow,” Carlos offered.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What if we need "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("the actress?")]), _vm._v("” Jay demanded. “I haven’t looked through the sequences we shot today.”")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("Carlos looked at Vanessa. “If Nessa doesn’t mind, ")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("she’s the same height and build and has long blond hair. She can fill in.”")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Yes, yes, Vanessa can fill in! You can be my stunt double!” Georgia said enthusiastically.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“For joy, for joy,” Vanessa murmured. But she was still disturbed by the young woman’s absolute terror. Georgia was ambitious. Was she really so terrified that she would walk away from what could be a big break for her?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She realized that everyone was staring at her.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Sure. Whatever is needed,” she said dryly to Jay. Of course she would do it. They both had a lot of hard work—not to mention their finances—tied up with this.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’ll be back in the morning,” Carlos promised. “Look, seriously, it’s what? Seven-thirty, eight o’clock now? I can make Miami in a few hours. I’ll get a night’s sleep and head back by five or six tomorrow morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It was agreed. In another hour, Carlos and Georgia were off.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Vanessa found herself sitting by the fire with the others, sipping champagne once again, though it had lost its taste.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I still think we should look for Travis,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Zoe let out an irritated “tsking” sound. “That jerk! He’s out there somewhere, laughing at everyone, and not caring that he’s put a real bug in the production.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“And messing with the props. When he walks up laughing and swaggering in the morning, I think we should give him a good right hook,” Barry said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Silence fell.")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Hey, we could sit here and tell ghost stories!” Bill suggested.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("They all glared at him. Apparently, no one was in the mood.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("For a while, they did reflect upon the many disappearances and oddities that had occurred in the Bermuda Triangle, but even that didn’t last long.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It was only nine-thirty when Vanessa opted for bed. She lay awake, watching the patterns of the low-burning fire playing upon the canvas roof of her tent. She thought about the ridiculousness of filming the movie—the hours of getting the characters into makeup and how, to save money, they had all taken on so many different tasks. Jay and Carlos had played the vengeful pirates, coming out of the sea, and she had supplied some of the sound effects and acted as the kidnapped and murdered Dona Isabella.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("Her script was honestly good, based on history and legend. Once, the Florida Keys and the Bahamas had been areas of lawlessness, ruled by pirates. An infamous pirate captain, Mad Miller, and his mistress, Kitty Cutlass, had gone on a wild reign of terror, taking ship after ship, or so legend said. Then all had gone wrong. They had taken a ship bearing the beautiful and rich Dona Isabella. They had sunk her ship, killed most of the crew and, presumably, planned on ransoming Dona Isabella. She had been sailing from Key West to Spain, back to her wealthy husband, when she had been taken. But nothing had happened as planned. Legend said that Kitty Cutlass killed Dona Isabella in a fit of rage, and on Haunt Island, Mad Miller went "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("really")]), _vm._v(" mad and massacred the remaining crew and many of his own men. ")]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("Finally, his pirate ship had sunk off Haunt Island, caught in the vengeful winds of a massive storm. Vanessa had based her script on the legend, doing what research she could, with contemporary teenagers finding themselves victims of bitter ghosts risen from the sand and the sea. As a screenplay, the story provided amazing fodder for the imagination. Filming had actually been fun. There had been some amusing accidents along the way, but none that had caused any harm. Bill had fallen into one of the buckets of blood, and Jake had come bolting up out of the water once, terrified of a nurse shark. She liked the people she was working with, and so, for the most part, it had been enjoyable. A crash shoot—all of it done within three weeks. And Jay was right—it could hit big at the box office.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("She still felt disturbed and uneasy, although she wasn’t alone. The tents were no more than a few feet apart. Jay, who had been bunking with Carlos, was next to her. Bill and Jake were on her left side. Lew, as secure a figure as anyone might ever want to meet, was just beyond Zoe.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("But she was still afraid. It was as if Georgia’s gut-wrenching scream had awakened something inside her that knew something was coming, something that she dreaded.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("At eleven o’clock, she was still staring at the canvas. She didn’t have anything really strong to help her sleep, but she decided on an over-the-counter aid. In another half an hour, she was asleep.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("It might have been the pill. She slept, but she tossed and turned and awakened throughout the night. And she dreamed that Georgia was standing in front of her, ")]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("giant tears dripping down her cheeks. “I told you, I told you there were monsters!”")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Georgia’s image disappeared.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She dreamed of giant shadow figures rising over her tent and of seaweed monsters rising out of the ocean, growing and growing and devouring ships, boats and people, and reaching up to the sky to snatch planes right from the atmosphere.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She awoke feeling better, laughing at herself for the absurdity of her dreams.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She didn’t believe in seaweed monsters—sea snakes, yes, sharks and other demons of the real world, but seaweed monsters, no.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("When she had nightmares, they were usually more logic-based—being chased in the darkness by a human killer, finding out she was in a dark house alone with a knife-wielding madman.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It had been Georgia. Georgia and that terrifying scream.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She blinked, stretched and rose. Taking off the long T-shirt nightgown she’d worn, she put on a bathing suit, ready to hit the beach. There were showers in the heads on both boats the crew had been using, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Seven Seas")]), _vm._v(" and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jalapeño.")]), _vm._v(" Of course, one boat wouldn’t be back until Carlos returned. It was a bright and beautiful morning, and she felt that a good dousing in the surf would be refreshing.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("She stepped out of her tent. The morning sun was shining, but the air retained a note of the night’s pleasant coolness. The sea stretched out before her, azure as it could only be in the Bahamas. Jay and Zoe were al")]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("ready up, and one of them had put the coffeepot to brew on the camp stove.")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Morning!” Jay called.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Morning!” she returned. “How long till coffee?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Hey! As fast as it brews!” Jay told her.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Zoe giggled. “What? Did you think this film had a budget for a cook?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Vanessa walked on out to the water. It was delightful; warm, but not too warm. So clear she could easily see the bottom, even when she had gone out about twenty-five feet from shore and the depth was around ten feet. The current of the Gulf Stream was sweeping the water around to the north; she decided to fight it and swim south, then let it bring her on back offshore from the campsite.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She swam a hard crawl, relaxed with a backstroke, worked on her butterfly and went back to doing the crawl, and then decided that she had gone far enough. She had angled herself in toward shore, so she paused a minute, standing, smoothing back her hair.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It was then that she looked toward the shore.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She would have screamed, but the sound froze in her throat.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She stood paralyzed, suddenly freezing as if she were a cube of ice in the balmy water.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The bones…the bodies…")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Georgia’s terrified words of the night before seemed to echo and bounce in her mind.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Then she did scream, loud and long. And she found sense and logic, amazingly, and started shouting for the others to come.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The bones…the bodies…")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("They were there. There was no sign of the boat, but Georgia Dare and Travis Glenn were there—in the sand. Their heads, eyes glaring open, were posed next to one another, staring toward the sea. Inches away from each, arms stretched out of the sand as well—just as props had done in the filming. It was as if they desperately reached out for help as the earth sucked them down, leaving only those pathetic heads, features frozen in silent screams.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jay had reached the scene. He was shaking and staring, in shock and denial. He shouted. “Travis, what is this, damn it! Georgia—no! No, no, no! Where is Carlos? What kind of a stunt is this?” Jerking like a mechanical figure, Jay went to touch the actor’s head, as if he could wake him up or snap him out of whatever game he was playing.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The head rolled through the sand. The body wasn’t attached.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jay himself began to scream.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Frozen still, shaking from a sudden cold that threatened never to leave her, Vanessa remained just offshore. She didn’t move until Lew had gotten the authorities, until a kindly Bahamian official came and wrapped a towel around her shoulders, and led her away.")])])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page31"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-186fefe0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781488099151_fm02.vue
// module id = 72
// module chunks = 0